<template>
    <li
        v-for="(part, idx) in textParts"
        :key="idx"
    >
        <TextyDivPart
            :html="part.html"
            :style-class="part.styleClass"
            :tema
            :is-last-div="false"
        />
    </li>
</template>

<script lang="ts" setup>
const { html, tema } = defineProps<{
    tema: TemaItem
    html: string
}>()

const REGEX_DIV_STYLES = "(<li>)(.*?)(</li>)"

type TextPart = {
    html: string
    styleClass: string
}

const textParts = computed<TextPart[]>(() => {
    const correctedText = correctText(html)
    const parts = splitTextToParts(correctedText)
    return processParts(parts).filter(part => part !== undefined)
})

function splitTextToParts(text: string) {
    // const regex = new RegExp(`${REGEX_FOOTNOTE}|${REGEX_STYLES}`, "g")
    const regex = new RegExp(`${REGEX_DIV_STYLES}`, "g")
    const matches = text.match(regex)

    return matches?.map(match => match) || []
}

function processParts(parts: string[]): Array<TextPart | undefined> {
    return parts.map(part => {
        const styleClass = "uap99"
        const groups = new RegExp(REGEX_DIV_STYLES)
        if (!styleClass) return
        return {
            html: part.replace(groups, "$2"),
            styleClass,
        }
    })
}

function correctText(text: string) {
    return text
        .replace(/🡪 Obr. /g, "🡪&nbsp;Obr.&nbsp;")
        .replace(/<sup><sup>/g, "<sup>")
        .replace(/<\/sup><\/sup>/g, "</sup>")
        .replace(/a href/g, 'a target="_blank" href')
}
</script>

<style scoped lang="scss">
:deep(ul),
:deep(.uap13),
:deep(.uap12) {
    @apply pl-8 text-lg;

    li {
        @apply relative mb-1 font-prolight last:mb-0;

        &::before {
            @apply absolute -left-7 top-px block pr-2 font-probold line-through;
            content: "\00a0\00a0\00a0\00a0\00a0";
        }
    }
}

/* :deep(.uap06) {
    @apply text-anotace;
}
:deep(.uap09) {
    @apply text-odstavec;
}
:deep(.uap20) {
    @apply text-zdroj-figury;
} */
</style>
